import { DiabetesProtocol, HypertensionProtocol } from "./ClinicalProtocol.ts";

export type EmrType = "none" | "athena";

export type ReportDeliveryMethod = "emr" | "fax";

export type FeatureFlag =
  | "MEDICATION_MANAGEMENT_DIABETES"
  | "PATIENT_EDUCATION_DIABETES"
  | "PATIENT_EDUCATION_HYPERTENSION"
  | "TRACK_MONTHLY_LIVE_INTERACTION"
  | "TRACK_MONTHLY_CLINICAL_TIME"
  | "CLINICIAN_APP_PATIENT_STICKY_NOTE"
  | string;

export type Organization = {
  id: string;
  name: string;
  emrType: EmrType;
  reportDeliveryMethods: ReportDeliveryMethod[];
  diabetesClinicalProtocols: DiabetesProtocol[];
  hypertensionClinicalProtocols: HypertensionProtocol[];
  featureFlags: FeatureFlag[];
};

export type OrganizationApiDto = {
  id: string;
  name: string;
  emrType: EmrType;
  reportDeliveryMethods: ReportDeliveryMethod[];
  diabetesClinicalProtocols: DiabetesProtocol[];
  hypertensionClinicalProtocols: HypertensionProtocol[];
  featureFlags: FeatureFlag[];
};

export const toOrganization = (dto: OrganizationApiDto): Organization => ({
  ...dto,
});

export const hasFeatureFlag = (
  organization: Organization | undefined,
  flag: FeatureFlag
): boolean => !!organization?.featureFlags.includes(flag);
